import type {ReactAction} from '@netx/core/bootstrap';
import {faPencil} from '@fortawesome/pro-solid-svg-icons';
import {SEARCH_SAVED_ACTION_LABELS} from '../locales';
import type {SavedSearch} from '../types';
import {SEARCH_SAVED_EVENT} from './constants';

export const searchSavedActionViewIcon = faPencil;

/**
 * View (and potentially edit) saved search
 * @param params
 * @returns Action
 */
export const searchSavedActionView = (
	savedSearch?: SavedSearch,
	params: Partial<ReactAction> = {},
): ReactAction => ({
	name: 'saved-search-view',
	cb: () => dispatcher.trigger(SEARCH_SAVED_EVENT.VIEW, savedSearch),
	icon: searchSavedActionViewIcon,
	get label() {
		return SEARCH_SAVED_ACTION_LABELS.VIEW;
	},
	...params,
});

export default searchSavedActionView;
